export { default } from './../plugins/directives'
